import type { TableMetric } from "@v2/features/analytics/constants";
import type { CurrencyCode } from "schemas/project";

import {
  METRICS_REQUIRING_CURRENCY,
  METRICS_REQUIRING_DECIMALS,
  METRICS_REQUIRING_PERCENTAGE,
} from "@v2/features/analytics/constants";
import { getCurrencySymbol } from "@v2/utils/currency";
import { formatWithCommasAndTwoDecimals } from "replo-utils/lib/math";

export function formatValueToTableCell({
  value,
  name,
  currency,
  touchType,
  isFractional,
}: {
  value: number;
  name: TableMetric;
  currency: CurrencyCode;
  touchType?: string;
  isFractional?: boolean;
}) {
  const showPercentage = METRICS_REQUIRING_PERCENTAGE.includes(name);
  const showCurrency = METRICS_REQUIRING_CURRENCY.includes(name);

  let showDecimalsFinal = METRICS_REQUIRING_DECIMALS.includes(name);

  if (name === "conversions") {
    if (isFractional) {
      showDecimalsFinal = true;
    } else if (touchType === "all" || touchType === "first") {
      showDecimalsFinal = false;
    }
  }

  if (showCurrency) {
    const symbol = getCurrencySymbol(currency);
    const formattedNumber = Intl.NumberFormat(navigator.language, {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(value);
    const space = symbol.length > 1 ? " " : "";
    return `${symbol}${space}${formattedNumber}`;
  }

  const formattedValue = formatWithCommasAndTwoDecimals(
    value,
    showDecimalsFinal,
  );

  return showPercentage ? `${formattedValue}%` : formattedValue;
}
